import axios from "../../axios";

export const filter = async (formData) => {
  try {
    const resp = await axios.post(`/internal/api/report/search`, formData);
    return resp.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

// export const filterByName = async (formData) => {

//   try {
//     const resp = await axios.post(
//       `/internal/api/report/all?page=0&size=25&order=desc&sortBy=lastUpdationOn`,
//       formData
//     );
//     console.log("dataaaaa", resp.data)
//     return resp.data;
//   } catch (error) {
//     throw new Error(error.message);
//   }
// };



// export const filterByreportId = async (formData) => {

//   try {
//     const resp = await axios.post(
//       `/internal/api/report/all?page=0&size=25&order=desc&sortBy=lastUpdationOn`,
//       formData
//     );
//     console.log("dataaaaa", resp.data)
//     return resp.data;
//   } catch (error) {
//     throw new Error(error.message);
//   }
// };
